// Browser copy of Legacy's GPS rule App\Rules\LaosCoordinate (Latsaman/small-b-backend#441).
// Keep the two in step: same bounds, same order of checks, same Lao text.
// No imports, so `node --test tests/*.test.mjs` can load this file without a bundler.

export const LAT_MIN = 13.9;
export const LAT_MAX = 22.6;
export const LNG_MIN = 100.0;
export const LNG_MAX = 107.8;
export const MIN_DECIMALS = 4;

// Where the map opens when a record has no GPS. Display only: never a field value.
export const DEFAULT_MAP_CENTER = { lat: 17.9614, lng: 102.6465 };

const AXIS = {
  lat: 'ເສັ້ນຂະໜານ (lat)',
  lng: 'ເສັ້ນແວງ (lng)',
};

// Same wording as Legacy resources/lang/la/validation.php `laos_coordinate` (+ `required`).
export const MESSAGES = {
  required: (axis) => `${AXIS[axis]} ບໍ່ສາມາດວ່າງເປົ່າໄດ້.`,
  pair: (axis) => `${AXIS[axis]} ຫວ່າງຢູ່. ໃຫ້ປ້ອນ GPS ທັງສອງຊ່ອງ ຫຼື ປ່ອຍຫວ່າງທັງສອງຊ່ອງ.`,
  numeric: (axis) => `${AXIS[axis]} ຕ້ອງເປັນຕົວເລກ (ຕົວຢ່າງ 18.10464).`,
  same: 'ເສັ້ນຂະໜານ ແລະ ເສັ້ນແວງ ຄືກັນ. ກະລຸນາກວດ GPS ຄືນ.',
  range_lat: 'ເສັ້ນຂະໜານ (lat) ຕ້ອງຢູ່ໃນປະເທດລາວ: ລະຫວ່າງ 13.9 ຫາ 22.6.',
  range_lng: 'ເສັ້ນແວງ (lng) ຕ້ອງຢູ່ໃນປະເທດລາວ: ລະຫວ່າງ 100.0 ຫາ 107.8.',
  decimals: (axis) => `${AXIS[axis]} ຕ້ອງມີທົດສະນິຍົມຢ່າງໜ້ອຍ 4 ຕົວ (ຕົວຢ່າງ 18.10464). ຖ້າບໍ່ຮູ້ຈຸດທີ່ແນ່ນອນ ໃຫ້ປ່ອຍຫວ່າງທັງສອງຊ່ອງ.`,
};

// The value to put in the form data: '' when unknown, else the trimmed string.
// formData.append('lat', null) would send the text "null", which is not empty.
export function gpsFieldValue(value) {
  if (value === null || value === undefined) return '';
  const text = String(value).trim();
  return text === 'null' || text === 'undefined' ? '' : text;
}

// True when both sides hold something (used to decide whether to drop a map pin).
export function hasGpsPoint(lat, lng) {
  return gpsFieldValue(lat) !== '' && gpsFieldValue(lng) !== '';
}

const isNumeric = (text) => text !== '' && !Number.isNaN(Number(text));

// One side's problem as a Lao message, or '' when fine. Same order as the server.
function problem(axis, value, other, required) {
  const v = gpsFieldValue(value);
  const o = gpsFieldValue(other);

  if (v === '') {
    if (required) return MESSAGES.required(axis);
    return o === '' ? '' : MESSAGES.pair(axis);
  }
  if (!isNumeric(v)) return MESSAGES.numeric(axis);
  if (o !== '' && isNumeric(o) && Number(v) === Number(o)) return MESSAGES.same;
  const [min, max] = axis === 'lat' ? [LAT_MIN, LAT_MAX] : [LNG_MIN, LNG_MAX];
  if (Number(v) < min || Number(v) > max) return MESSAGES[`range_${axis}`];
  const decimals = /^-?\d+\.(\d+)$/.exec(v);
  if (!decimals || decimals[1].length < MIN_DECIMALS) return MESSAGES.decimals(axis);
  return '';
}

// Check a lat/lng pair. `required` is for the lead form (company_requests, NOT NULL columns).
// Returns { lat, lng } with a Lao message per field, '' where that field is fine.
export function checkLaosPair(lat, lng, { required = false } = {}) {
  return {
    lat: problem('lat', lat, lng, required),
    lng: problem('lng', lng, lat, required),
  };
}
